import { render, staticRenderFns } from "./rePwd.vue?vue&type=template&id=5c9a5f55&scoped=true"
import script from "./rePwd.vue?vue&type=script&lang=js"
export * from "./rePwd.vue?vue&type=script&lang=js"
import style0 from "./rePwd.vue?vue&type=style&index=0&id=5c9a5f55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a5f55",
  null
  
)

export default component.exports